export const PLANS = {
  TRIAL: {
    name: 'Plano Inicial',
    price: 7.47,
    features: [
      'Todas as funcionalidades do plano PRO',
      '7 dias de teste',
      'Busca de Leads Ilimitadas',
      'Consultas ilimitadas',
      'Suporte VIP no WhatsApp',
      'Relatórios detalhados'
    ]
  },
  ESSENTIAL: {
    name: 'Plano Essencial',
    price: 17,
    features: [
      '30 consultas por 30 dias',
      'Busca de Leads com até 10 contatos por vez',
      'Chat com IA ilimitado',
      'Relatório detalhado de Persona e Segmentação',
      'Dashboard de Previsões por Principais Nichos'
    ]
  },
  PRO: {
    name: 'Plano PRO',
    price: 27,
    features: [
      'Consultas ILIMITADAS',
      'Busca de Leads Ilimitada',
      'Insights Extras de IA',
      'Sugestões de Otimização de Anúncios',
      'Suporte VIP no WhatsApp',
      'Relatórios de Tendências do Mercado'
    ]
  },
  ANNUAL: {
    name: 'Plano ANUAL',
    price: 247,
    features: [
      '12 meses de acesso com quase 30% de desconto',
      'Busca de Leads Ilimitada',
      'Relatórios com insights de nichos',
      'Suporte prioritário nível 1',
      'Todas as funcionalidades do plano PRO'
    ]
  }
};